// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* margin-bottom: 1vw; */
  padding: 1.1rem 1.5rem;
}

.fileName {
  color: #8b8b8b;
  font-size: 18px !important;
  font-family: poppins !important;
  font-weight: 500 !important;
}

.catgeory-section-header {
  display: flex;
  color: #fff;
  gap: 0.5rem;
  height: 5vh;
  align-items: center;
  padding: 0rem 1.5rem;
  /* border: 1px solid red; */
}

.catgeoryName {
  font-size: 0.9vw !important;
  font-family: poppins !important;
  font-weight: 500 !important;
}

.img-file {
  height: 165px;
  width: 165px;
  border-radius: 0.2vw;
}
`, "",{"version":3,"sources":["webpack://./src/features/Setting/order/components/orderFileModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,oBAAoB;AACtB","sourcesContent":[".file-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  /* margin-bottom: 1vw; */\n  padding: 1.1rem 1.5rem;\n}\n\n.fileName {\n  color: #8b8b8b;\n  font-size: 18px !important;\n  font-family: poppins !important;\n  font-weight: 500 !important;\n}\n\n.catgeory-section-header {\n  display: flex;\n  color: #fff;\n  gap: 0.5rem;\n  height: 5vh;\n  align-items: center;\n  padding: 0rem 1.5rem;\n  /* border: 1px solid red; */\n}\n\n.catgeoryName {\n  font-size: 0.9vw !important;\n  font-family: poppins !important;\n  font-weight: 500 !important;\n}\n\n.img-file {\n  height: 165px;\n  width: 165px;\n  border-radius: 0.2vw;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
